const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/newsletter/posts/$id/content.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { newsletterRoutes } from "@circle-react/lib/routes/newsletter";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchNewsletterPost, isPostEditable } from "@/react/components/SettingsApp/Newsletters/helpers";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/newsletter/posts/$id/content")({
  beforeLoad: async ({
    params,
    context
  }) => {
    const post = await fetchNewsletterPost(context.queryClient, params.id);
    if (!post || isPostEditable(post)) return;
    redirect({
      href: newsletterRoutes.postOverview({
        path: {
          id: params.id
        }
      }),
      replace: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});